import { render } from "./GoalKRNameActivity.vue?vue&type=template&id=3a6e9d78"
import script from "./GoalKRNameActivity.vue?vue&type=script&lang=js"
export * from "./GoalKRNameActivity.vue?vue&type=script&lang=js"
script.render = render

export default script